/* Moved out of templates/page.review.capture.liquid (the review / check-in capture page) into this cached file on 2026-10-25. The text is exactly what was printed into the page before: it had no Liquid in it. */
    (function() {
      // ─── Config ──────────────────────────────────
      var WORKER_URL = 'https://personapath-reviews-worker.personapath.workers.dev';
      var STAR_LABELS = ['', 'Poor', 'Below average', 'Good', 'Very good', 'Excellent'];
      var STAR_SVG = '<svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';

      // ─── URL Params ─────────────────────────────
      var params = new URLSearchParams(window.location.search);
      var isCheckinMode = params.get('mode') === 'checkin';
      var checkinCustomerId = params.get('customer_id') || '';
      var checkinCycle = parseInt(params.get('cycle') || '1', 10);
      var checkinFocusParam = params.get('focus') || '';

      // ═══════════════════════════════════════════════
      // CHECK-IN DATA DEFINITIONS
      // ═══════════════════════════════════════════════

      var SLIDER_DEFS = {
        energy: {
          question: 'How would you describe your energy levels?',
          low: 'Low',
          high: 'Great',
          s: [
            '',
            'I feel exhausted or drained most of the day',
            'My energy is low and I rely on caffeine or naps to get through',
            'My energy is okay but inconsistent',
            'I have good energy most days with only occasional dips',
            'I feel consistently energized throughout the day'
          ]
        },
        mood_general: {
          question: 'How would you describe your overall mood?',
          low: 'Low',
          high: 'Great',
          s: [
            '',
            'I feel overwhelmed, anxious, or low most of the time',
            'My mood is often affected by stress or low periods',
            'I have ups and downs but I manage',
            'I feel generally balanced with only occasional rough patches',
            'I feel calm, positive, and emotionally resilient'
          ]
        },
        sleep: {
          question: 'How would you describe your sleep?',
          low: 'Poor',
          high: 'Great',
          s: [
            '',
            'I struggle to fall or stay asleep most nights',
            'My sleep is restless and I rarely feel rested in the morning',
            'Some nights are fine, others not so much',
            'I sleep well most nights and usually wake up feeling okay',
            'I fall asleep easily, sleep deeply, and wake up refreshed'
          ]
        },
        mood_stress: {
          question: 'How well are you managing your mood and stress?',
          low: 'Low',
          high: 'Great',
          s: [
            '',
            'I feel overwhelmed, anxious, or low most of the time',
            'Stress or low mood affects my daily life regularly',
            'I have ups and downs but I manage',
            'I feel generally balanced with only occasional rough patches',
            'I feel calm, positive, and emotionally resilient'
          ]
        },
        digestion: {
          question: 'How comfortable is your digestion?',
          low: 'Poor',
          high: 'Great',
          s: [
            '',
            'I deal with discomfort, bloating, or irregularity daily',
            'Digestive issues come up frequently and bother me',
            'It\'s okay most days but not great',
            'My digestion feels comfortable and regular most of the time',
            'No complaints at all, everything feels smooth'
          ]
        },
        beauty: {
          question: 'How are your hair, skin, and nails?',
          low: 'Poor',
          high: 'Great',
          s: [
            '',
            'I\'m dealing with noticeable breakage, breakouts, or brittleness',
            'My skin, hair, or nails feel dull, dry, or weak',
            'Things are okay but nothing I\'d call healthy or glowing',
            'I\'m noticing improvements in texture, strength, or appearance',
            'My skin is clear, hair feels strong, nails are healthy'
          ]
        },
        sport: {
          question: 'How is your exercise performance and recovery?',
          low: 'Poor',
          high: 'Great',
          s: [
            '',
            'I feel sore for days and my performance feels limited',
            'Recovery takes longer than I\'d like and I tire quickly',
            'I can get through my workouts but recovery is hit or miss',
            'I feel good during exercise and recover reasonably well',
            'I feel strong, recover quickly, and perform at my best'
          ]
        },
        bones_joints: {
          question: 'How do your bones and joints feel?',
          low: 'Poor',
          high: 'Great',
          s: [
            '',
            'I deal with stiffness, pain, or limited mobility daily',
            'Joint or bone discomfort comes up regularly',
            'Some stiffness or discomfort but it doesn\'t stop me',
            'I feel mostly comfortable with only occasional tightness',
            'I move freely with no discomfort'
          ]
        },
        brain: {
          question: 'How is your mental clarity and focus?',
          low: 'Poor',
          high: 'Great',
          s: [
            '',
            'I feel foggy, forgetful, or unable to concentrate',
            'My focus fades quickly and I struggle with mental tasks',
            'I can focus when I need to but it takes effort',
            'I feel mentally sharp most of the time',
            'My mind feels clear, focused, and mentally quick'
          ]
        },
        womens_health: {
          question: 'How would you rate your women\'s health overall?',
          low: 'Poor',
          high: 'Great',
          s: [
            '',
            'My symptoms significantly affect my daily life',
            'I regularly deal with discomfort or hormonal symptoms',
            'Some months are better than others',
            'Things feel mostly manageable and comfortable',
            'I feel balanced, comfortable, and in tune with my body'
          ]
        },
        mens_health: {
          question: 'How would you rate your men\'s health overall?',
          low: 'Poor',
          high: 'Great',
          s: [
            '',
            'I\'m experiencing noticeable issues with vitality or comfort',
            'Things don\'t feel quite right and it\'s on my mind',
            'No major complaints but room for improvement',
            'I feel good overall with only minor things',
            'I feel strong, healthy, and comfortable'
          ]
        },
        hormonal_balance: {
          question: 'How balanced do your hormones feel?',
          low: 'Poor',
          high: 'Great',
          s: [
            '',
            'Hormonal symptoms significantly disrupt my life',
            'I frequently deal with breakouts, mood shifts, or irregularity',
            'Some symptoms but I can manage',
            'Things feel mostly stable and balanced',
            'I feel hormonally balanced with no noticeable symptoms'
          ]
        },
        maternity: {
          question: 'How are you feeling through this stage?',
          low: 'Tough',
          high: 'Great',
          s: [
            '',
            'I\'m struggling with fatigue, nausea, or symptoms daily',
            'Symptoms are frequent and draining',
            'Some tough days but some good ones too',
            'I feel mostly well and supported',
            'I feel strong, nourished, and well through this stage'
          ]
        }
      };

      var TOGGLE_DEFS = {
        heart: {
          question: 'Heart health',
          framing: 'Heart health is a long-term investment. Changes happen gradually over months and years, not overnight. That said, have you noticed anything different?',
          options: [
            { v: 'better', l: 'I feel better overall' },
            { v: 'no_change', l: 'No noticeable change yet (totally normal)' },
            { v: 'concerns', l: 'I have some concerns' }
          ]
        },
        immunity: {
          question: 'Immune resilience',
          framing: 'Your immune system strengthens gradually. Have you noticed any difference in how often you get sick or feel run down?',
          options: [
            { v: 'better', l: 'I feel more resilient' },
            { v: 'no_change', l: 'No noticeable change yet (totally normal)' },
            { v: 'concerns', l: 'I have some concerns' }
          ]
        },
        vision: {
          question: 'Eye health',
          framing: 'Eye health is one of the slower areas to show change. Have you noticed anything different with eye comfort, strain, or dryness?',
          options: [
            { v: 'better', l: 'I\'ve noticed some improvement' },
            { v: 'no_change', l: 'No noticeable change yet (totally normal)' },
            { v: 'concerns', l: 'I have some concerns' }
          ]
        },
        longevity: {
          question: 'Healthy aging',
          framing: 'Longevity supplements support your body at a cellular level, so changes aren\'t something you feel day to day. That said, how are you feeling overall?',
          options: [
            { v: 'better', l: 'I feel good overall' },
            { v: 'no_change', l: 'No noticeable change yet (totally normal)' },
            { v: 'concerns', l: 'I have some concerns' }
          ]
        }
      };

      // ─── Focus Area Mappings ────────────────────
      var FOCUS_TO_SLIDER = {
        energy: 'energy', sleep: 'sleep', mood_stress: 'mood_stress',
        digestion: 'digestion', skin: 'beauty', hair: 'beauty', nails: 'beauty',
        sport: 'sport', bones_joints: 'bones_joints', brain: 'brain',
        womens_health: 'womens_health', mens_health: 'mens_health',
        hormonal_balance: 'hormonal_balance', maternity: 'maternity'
      };

      var FOCUS_TO_TOGGLE = {
        heart: 'heart', immunity: 'immunity',
        vision: 'vision', longevity: 'longevity', aging: 'longevity'
      };

      var LIFE_OPTIONS = [
        { id: 'ttc_female', l: 'Trying to conceive' },
        { id: 'ttc_male', l: 'Partner and I are trying to conceive' },
        { id: 'pregnant_t1', l: 'I\'m pregnant (1st trimester)' },
        { id: 'pregnant_t2', l: 'I\'m pregnant (2nd trimester)' },
        { id: 'pregnant_t3', l: 'I\'m pregnant (3rd trimester)' },
        { id: 'breastfeeding', l: 'I\'m breastfeeding' },
        { id: 'increased_workload', l: 'Work has been more demanding lately' },
        { id: 'high_stress', l: 'I\'m going through a stressful period' },
        { id: 'started_exercising', l: 'I\'ve started exercising more' },
        { id: 'changed_diet', l: 'I\'ve changed my diet significantly' },
        { id: 'new_medication', l: 'I\'ve started a new medication' },
        { id: 'menopause', l: 'I\'m experiencing menopause symptoms' },
        { id: 'holiday_planned', l: 'I\'m going on holiday soon' },
        { id: 'none', l: 'Nothing has changed' }
      ];

      // ═══════════════════════════════════════════════
      // STATE
      // ═══════════════════════════════════════════════

      var stepFlow = [];
      var currentStepIndex = 0;
      var checkinSubmitted = false;

      // Check-in state
      var ciActiveSliders = [];
      var ciActiveToggles = [];
      var ciHasQualitative = false;
      var ciBaselineScores = {};
      var ciCurrentScores = {};
      var ciToggleScores = {};
      var ciLifeUpdates = [];
      var ciSuppFeedback = {};
      var ciWantsReview = null;

      // Review state
      var hasProducts = false;
      var productRatings = {};

      var reviewData = {
        reviewer_name: '',
        reviewer_email: '',
        product_id: '',
        product_title: '',
        rating_overall: 0,
        title: '',
        body: '',
        duration_of_use: '',
        would_recommend: null,
        satisfaction: null,
        outcome_energy: null,
        outcome_sleep: null,
        outcome_mood: null,
        outcome_digestion: null,
        outcome_skin: null,
        outcome_focus: null,
        product_ratings: [],
        media_urls: []
      };

      // Media upload state
      var uploadedMedia = [];
      var MAX_FILES = 5;
      var MAX_IMAGE_SIZE = 25 * 1024 * 1024;
      var MAX_VIDEO_SIZE = 100 * 1024 * 1024;
      var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'video/mp4', 'video/quicktime'];

      // ═══════════════════════════════════════════════
      // STEP FLOW ENGINE
      // ═══════════════════════════════════════════════

      function buildStepFlow() {
        if (isCheckinMode) {
          stepFlow = ['1'];
          if (checkinCycle <= 1) {
            stepFlow.push('ci-baseline');
          }
          stepFlow.push('ci-current');
          if (ciHasQualitative) {
            stepFlow.push('ci-qualitative');
          }
          stepFlow.push('ci-life', 'ci-supplements', 'ci-transition');
        } else {
          stepFlow = ['1', 'r-satisfaction'];
          if (hasProducts) {
            stepFlow.push('r-products');
          }
          stepFlow.push('r-stars', 'r-outcomes', 'r-duration', 'r-recommend', 'r-write', 'r-confirm', 'r-done');
        }
      }

      function goToStep(id) {
        var idx = stepFlow.indexOf(id);
        if (idx === -1) return;
        currentStepIndex = idx;

        document.querySelectorAll('.step').forEach(function(s) {
          s.classList.remove('active');
        });

        var target = document.querySelector('[data-step="' + id + '"]');
        if (target) {
          target.classList.add('active');
          var progress = Math.min((idx / (stepFlow.length - 1)) * 100, 100);
          document.getElementById('progressFill').style.width = progress + '%';
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }

      function goNext() {
        if (currentStepIndex < stepFlow.length - 1) {
          goToStep(stepFlow[currentStepIndex + 1]);
        }
      }

      function goBack() {
        if (currentStepIndex > 0) {
          goToStep(stepFlow[currentStepIndex - 1]);
        }
      }

      // Wire all back buttons
      document.querySelectorAll('[data-back]').forEach(function(btn) {
        btn.addEventListener('click', goBack);
      });

      // Wire generic next buttons
      document.querySelectorAll('[data-next]').forEach(function(btn) {
        btn.addEventListener('click', goNext);
      });

      // ═══════════════════════════════════════════════
      // URL PARAMS → PRE-FILL
      // ═══════════════════════════════════════════════

      if (params.get('email')) {
        reviewData.reviewer_email = decodeURIComponent(params.get('email'));
        document.getElementById('reviewerEmail').value = reviewData.reviewer_email;
      }
      if (params.get('name')) {
        reviewData.reviewer_name = decodeURIComponent(params.get('name'));
        document.getElementById('reviewerName').value = reviewData.reviewer_name;
        document.getElementById('prefilledName').textContent = reviewData.reviewer_name;
        document.getElementById('prefilledInfo').style.display = 'flex';
        document.getElementById('manualNameGroup').style.display = 'none';
      }
      if (params.get('product_id')) {
        reviewData.product_id = decodeURIComponent(params.get('product_id'));
      }
      if (params.get('product_title')) {
        reviewData.product_title = decodeURIComponent(params.get('product_title'));
      }
      if (reviewData.reviewer_email) {
        document.getElementById('manualEmailGroup').style.display = 'none';
      }

      // ═══════════════════════════════════════════════
      // BUILD CHECK-IN UI COMPONENTS
      // ═══════════════════════════════════════════════

      function buildSliders(containerId, sliderIds) {
        var container = document.getElementById(containerId);
        if (!container) return;

        var isBaseline = containerId === 'ciBaselineSliders';
        var html = '';

        sliderIds.forEach(function(id) {
          var def = SLIDER_DEFS[id];
          if (!def) return;

          html += '<div class="ci-slider">';
          html += '<div class="ci-slider__question">' + def.question + '</div>';
          html += '<div class="ci-slider__scale">';
          for (var i = 1; i <= 5; i++) {
            html += '<div class="ci-slider__dot" data-ci-val="' + i + '" data-ci-id="' + id + '" data-ci-base="' + (isBaseline ? 1 : 0) + '">' + i + '</div>';
          }
          html += '</div>';
          html += '<div class="ci-slider__endpoints"><span>' + def.low + '</span><span>' + def.high + '</span></div>';
          html += '<div class="ci-slider__desc" data-ci-desc="' + containerId + '-' + id + '"></div>';
          html += '</div>';
        });

        container.innerHTML = html;

        // Bind click events
        container.querySelectorAll('.ci-slider__dot').forEach(function(dot) {
          dot.addEventListener('click', function() {
            var val = parseInt(dot.dataset.ciVal);
            var sliderId = dot.dataset.ciId;
            var isBase = dot.dataset.ciBase === '1';

            if (isBase) {
              ciBaselineScores[sliderId] = val;
            } else {
              ciCurrentScores[sliderId] = val;
            }

            // Update visual state
            dot.closest('.ci-slider__scale').querySelectorAll('.ci-slider__dot').forEach(function(d) {
              d.classList.toggle('selected', parseInt(d.dataset.ciVal) === val);
            });

            // Update description
            var descEl = document.querySelector('[data-ci-desc="' + containerId + '-' + sliderId + '"]');
            if (descEl && SLIDER_DEFS[sliderId]) {
              descEl.textContent = SLIDER_DEFS[sliderId].s[val] || '';
            }
          });
        });
      }

      function buildToggles() {
        var container = document.getElementById('ciToggles');
        if (!container || ciActiveToggles.length === 0) return;

        var html = '';

        ciActiveToggles.forEach(function(id) {
          var def = TOGGLE_DEFS[id];
          if (!def) return;

          html += '<div class="ci-toggle">';
          html += '<div class="ci-toggle__question">' + def.question + '</div>';
          html += '<div class="ci-toggle__framing">' + def.framing + '</div>';
          html += '<div class="ci-toggle__options">';
          def.options.forEach(function(opt) {
            html += '<div class="ci-toggle__btn" data-tid="' + id + '" data-tv="' + opt.v + '">' + opt.l + '</div>';
          });
          html += '</div></div>';
        });

        container.innerHTML = html;

        // Bind clicks
        container.querySelectorAll('.ci-toggle__btn').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var toggleId = btn.dataset.tid;
            var val = btn.dataset.tv;
            ciToggleScores[toggleId] = val;

            container.querySelectorAll('[data-tid="' + toggleId + '"]').forEach(function(b) {
              b.classList.toggle('selected', b.dataset.tv === val);
            });
          });
        });
      }

      function buildLifeOptions() {
        var container = document.getElementById('ciLifeGrid');
        if (!container) return;

        var html = '';
        LIFE_OPTIONS.forEach(function(opt) {
          html += '<div class="ci-life-btn" data-ci-life="' + opt.id + '">' + opt.l + '</div>';
        });
        container.innerHTML = html;

        container.querySelectorAll('.ci-life-btn').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var id = btn.dataset.ciLife;

            if (id === 'none') {
              // Deselect everything, select "none"
              ciLifeUpdates.length = 0;
              ciLifeUpdates.push('none');
              container.querySelectorAll('.ci-life-btn').forEach(function(b) {
                b.classList.toggle('selected', b.dataset.ciLife === 'none');
              });
            } else {
              // Deselect "none" if selected
              var noneIdx = ciLifeUpdates.indexOf('none');
              if (noneIdx !== -1) {
                ciLifeUpdates.splice(noneIdx, 1);
                container.querySelector('[data-ci-life="none"]').classList.remove('selected');
              }

              // Toggle this option
              var idx = ciLifeUpdates.indexOf(id);
              if (idx !== -1) {
                ciLifeUpdates.splice(idx, 1);
                btn.classList.remove('selected');
              } else {
                ciLifeUpdates.push(id);
                btn.classList.add('selected');
              }
            }
          });
        });
      }

      function buildSuppFeedback() {
        var container = document.getElementById('ciSuppList');
        if (!container) return;

        var productsStr = params.get('products');
        if (!productsStr) {
          container.innerHTML = '<div style="text-align:center;color:var(--pp-mid);font-size:15px;padding:20px 0;">' + window.PP_REVIEW_STRINGS.no_supplements_found + '</div>';
          return;
        }

        var handles = productsStr.split(',').map(function(h) { return h.trim(); }).filter(Boolean);

        handles.forEach(function(handle) {
          fetch('/products/' + handle + '.js')
            .then(function(res) { return res.ok ? res.json() : null; })
            .then(function(product) {
              if (!product) return;

              var imgSrc = product.featured_image
                ? product.featured_image.replace(/(\.[^.]+)$/, '_200x200$1')
                : '';

              var card = document.createElement('div');
              card.className = 'ci-supp';

              card.innerHTML = '<div class="ci-supp__top">'
                + (imgSrc ? '<img class="ci-supp__img" src="' + imgSrc + '" alt="' + product.title + '">' : '')
                + '<div class="ci-supp__name">' + product.title + '</div>'
                + '</div>'
                + '<div class="ci-supp__feedback">'
                + '<div class="ci-supp__fbtn" data-sh="' + handle + '" data-sv="helpful">I can feel a difference</div>'
                + '<div class="ci-supp__fbtn" data-sh="' + handle + '" data-sv="unsure">Not sure yet</div>'
                + '<div class="ci-supp__fbtn" data-sh="' + handle + '" data-sv="none">No noticeable effect</div>'
                + '</div>';

              container.appendChild(card);

              card.querySelectorAll('.ci-supp__fbtn').forEach(function(fb) {
                fb.addEventListener('click', function() {
                  ciSuppFeedback[handle] = fb.dataset.sv;
                  card.querySelectorAll('.ci-supp__fbtn').forEach(function(b) {
                    b.classList.toggle('selected', b.dataset.sv === fb.dataset.sv);
                  });
                });
              });
            })
            .catch(function() {});
        });
      }

      // ═══════════════════════════════════════════════
      // MODE INITIALIZATION
      // ═══════════════════════════════════════════════

      if (isCheckinMode) {
        // Update welcome screen
        document.getElementById('welcomeTitle').textContent = window.PP_REVIEW_STRINGS.monthly_checkin;
        document.getElementById('welcomeSubtitle').textContent = window.PP_REVIEW_STRINGS.share_subtitle;
        document.getElementById('headerProduct').textContent = window.PP_REVIEW_STRINGS.checkin_label + (checkinCycle > 0 ? ' #' + checkinCycle : '');

        // Determine which sliders and toggles to show
        var focusAreas = checkinFocusParam ? checkinFocusParam.split(',').map(function(s) { return s.trim(); }) : [];

        // Universal: always show energy
        ciActiveSliders.push('energy');

        // Check if mood_stress is a focus area
        var hasMoodStress = focusAreas.indexOf('mood_stress') !== -1;

        // Map focus areas to sliders and toggles
        focusAreas.forEach(function(area) {
          var sliderId = FOCUS_TO_SLIDER[area];
          if (sliderId && ciActiveSliders.indexOf(sliderId) === -1) {
            ciActiveSliders.push(sliderId);
          }
          var toggleId = FOCUS_TO_TOGGLE[area];
          if (toggleId && ciActiveToggles.indexOf(toggleId) === -1) {
            ciActiveToggles.push(toggleId);
          }
        });

        // Add universal mood if mood_stress isn't already a slider
        if (!hasMoodStress && ciActiveSliders.indexOf('mood_stress') === -1) {
          var energyIdx = ciActiveSliders.indexOf('energy');
          ciActiveSliders.splice(energyIdx + 1, 0, 'mood_general');
        }

        ciHasQualitative = ciActiveToggles.length > 0;

        // Build check-in UI components
        buildSliders('ciBaselineSliders', ciActiveSliders);
        buildSliders('ciCurrentSliders', ciActiveSliders);
        buildToggles();
        buildLifeOptions();
        buildSuppFeedback();
      } else {
        // Review-only mode
        if (reviewData.product_title) {
          document.getElementById('headerProduct').textContent = window.PP_REVIEW_STRINGS.reviewing_prefix + ' ' + reviewData.product_title;
        }

        var productsParam = params.get('products');
        if (productsParam) {
          hasProducts = true;
          var handles = productsParam.split(',').map(function(h) { return h.trim(); }).filter(Boolean);
          loadProducts(handles);
        }
      }

      // Build flow and start
      buildStepFlow();
      goToStep('1');

      // ═══════════════════════════════════════════════
      // CHECK-IN BUTTON HANDLERS
      // ═══════════════════════════════════════════════

      var btnCiBaseline = document.getElementById('btnCiBaseline');
      if (btnCiBaseline) btnCiBaseline.addEventListener('click', goNext);

      var btnCiCurrent = document.getElementById('btnCiCurrent');
      if (btnCiCurrent) btnCiCurrent.addEventListener('click', goNext);

      var btnCiToggles = document.getElementById('btnCiToggles');
      if (btnCiToggles) btnCiToggles.addEventListener('click', goNext);

      var btnCiLife = document.getElementById('btnCiLife');
      if (btnCiLife) btnCiLife.addEventListener('click', goNext);

      var btnCiSupps = document.getElementById('btnCiSupps');
      if (btnCiSupps) {
        btnCiSupps.addEventListener('click', function() {
          submitCheckin();
          goNext();
        });
      }

      // Transition: review yes/no
      document.querySelectorAll('[data-ci-review]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          ciWantsReview = btn.dataset.ciReview === 'yes';
          document.querySelectorAll('[data-ci-review]').forEach(function(b) {
            b.classList.remove('selected');
          });
          btn.classList.add('selected');
          document.getElementById('btnCiTransition').disabled = false;
        });
      });

      var btnCiTransition = document.getElementById('btnCiTransition');
      if (btnCiTransition) {
        btnCiTransition.addEventListener('click', function() {
          if (ciWantsReview) {
            // Append review steps to the flow
            var reviewSteps = ['r-satisfaction'];
            if (hasProducts) reviewSteps.push('r-products');
            reviewSteps.push('r-stars', 'r-outcomes', 'r-duration', 'r-recommend', 'r-write', 'r-confirm', 'r-done');

            var transIdx = stepFlow.indexOf('ci-transition');
            stepFlow = stepFlow.slice(0, transIdx + 1).concat(reviewSteps);
            goNext();
          } else {
            stepFlow.push('ci-done');
            goNext();
          }
        });
      }

      // ─── Submit Check-in to Worker ──────────────
      async function submitCheckin() {
        if (checkinSubmitted) return;
        checkinSubmitted = true;

        var payload = {
          customer_id: checkinCustomerId,
          cycle: checkinCycle,
          scores: ciCurrentScores,
          qualitative: ciToggleScores,
          supplement_feedback: ciSuppFeedback,
          life_updates: ciLifeUpdates.length > 0 ? ciLifeUpdates : ['none'],
          reviewer_name: reviewData.reviewer_name,
          reviewer_email: reviewData.reviewer_email
        };

        // Include baseline if cycle 1
        if (checkinCycle <= 1 && Object.keys(ciBaselineScores).length > 0) {
          payload.baseline_scores = ciBaselineScores;
        }

        try {
          var res = await fetch(WORKER_URL + '/api/submit-checkin', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          var data = await res.json();

          if (data.has_recommendation) {
            document.getElementById('ciDoneText').textContent =
              "Thanks for sharing how you're doing. Based on your check-in, we have a recommendation for your plan. Check your dashboard to review it.";
          }
          console.log('Check-in submitted:', data);
        } catch (err) {
          console.error('Check-in submit error:', err);
        }
      }

      // ═══════════════════════════════════════════════
      // REVIEW FUNCTIONALITY
      // ═══════════════════════════════════════════════

      // ─── Step 1: Welcome ────────────────────────
      document.getElementById('btnStart').addEventListener('click', function() {
        var name = document.getElementById('reviewerName').value.trim();
        var email = document.getElementById('reviewerEmail').value.trim();

        if (!name) { showError('Please enter your name.'); return; }
        if (!reviewData.reviewer_email && !email) { showError('Please enter your email.'); return; }
        if (email && !email.includes('@')) { showError('Please enter a valid email address.'); return; }

        reviewData.reviewer_name = name;
        if (email) reviewData.reviewer_email = email;
        hideError();
        goNext();
      });

      // ─── Satisfaction ───────────────────────────
      document.querySelectorAll('[data-satisfaction]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          reviewData.satisfaction = btn.dataset.satisfaction;
          document.querySelectorAll('[data-satisfaction]').forEach(function(b) {
            b.classList.remove('selected');
          });
          btn.classList.add('selected');
          document.getElementById('btnSatisfaction').disabled = false;
        });
      });

      document.getElementById('btnSatisfaction').addEventListener('click', goNext);

      // ─── Product Ratings ────────────────────────
      var btnProducts = document.getElementById('btnProducts');
      if (btnProducts) btnProducts.addEventListener('click', goNext);

      async function loadProducts(handles) {
        var container = document.getElementById('productRatingsList');
        var loading = document.getElementById('productsLoading');
        var html = '';

        for (var i = 0; i < handles.length; i++) {
          var handle = handles[i];
          try {
            var res = await fetch('/products/' + handle + '.js');
            if (!res.ok) continue;
            var product = await res.json();

            var imgSrc = product.featured_image
              ? product.featured_image.replace(/(\.[^.]+)$/, '_200x200$1')
              : '';

            productRatings[handle] = {
              rating: 0,
              comment: '',
              title: product.title,
              productId: 'gid://shopify/Product/' + product.id
            };

            html += '<div class="product-rating-card" data-product-handle="' + handle + '">'
              + '<div class="product-rating-card__top">'
              + (imgSrc ? '<img class="product-rating-card__image" src="' + imgSrc + '" alt="' + product.title + '">' : '')
              + '<div class="product-rating-card__info">'
              + '<div class="product-rating-card__title">' + product.title + '</div>'
              + '<div class="product-rating-card__stars" data-handle="' + handle + '">'
              + [1,2,3,4,5].map(function(v) {
                  return '<div class="product-rating-card__star" data-val="' + v + '">' + STAR_SVG + '</div>';
                }).join('')
              + '</div></div></div>'
              + '<div class="product-rating-card__comment" id="comment-' + handle + '">'
              + '<textarea placeholder="Add a comment (optional)" data-comment-handle="' + handle + '"></textarea>'
              + '</div></div>';
          } catch (err) {
            console.error('Failed to load product:', handle, err);
          }
        }

        if (html) {
          loading.style.display = 'none';
          container.insertAdjacentHTML('beforeend', html);
          initProductStars();
        } else {
          loading.textContent = 'No products found.';
        }
      }

      function initProductStars() {
        document.querySelectorAll('.product-rating-card__stars').forEach(function(starsContainer) {
          var handle = starsContainer.dataset.handle;
          var starEls = starsContainer.querySelectorAll('.product-rating-card__star');
          var commentEl = document.getElementById('comment-' + handle);

          starEls.forEach(function(star) {
            star.addEventListener('click', function() {
              var val = parseInt(star.dataset.val);
              productRatings[handle].rating = val;
              starEls.forEach(function(s, i) {
                s.classList.toggle('filled', i < val);
              });
              commentEl.classList.add('open');
            });

            star.addEventListener('mouseenter', function() {
              var val = parseInt(star.dataset.val);
              starEls.forEach(function(s, i) {
                s.classList.toggle('filled', i < val);
              });
            });

            star.addEventListener('mouseleave', function() {
              var currentRating = productRatings[handle].rating;
              starEls.forEach(function(s, i) {
                s.classList.toggle('filled', i < currentRating);
              });
            });
          });

          var textarea = commentEl.querySelector('textarea');
          if (textarea) {
            textarea.addEventListener('input', function() {
              productRatings[handle].comment = textarea.value;
            });
          }
        });
      }

      // ─── Overall Star Rating ────────────────────
      var stars = document.querySelectorAll('#starRating .star-rating__star');
      stars.forEach(function(star) {
        star.addEventListener('click', function() {
          var val = parseInt(star.dataset.value);
          reviewData.rating_overall = val;
          stars.forEach(function(s, i) {
            s.classList.toggle('filled', i < val);
          });
          document.getElementById('starLabel').textContent = STAR_LABELS[val];
          document.getElementById('btnRating').disabled = false;
        });

        star.addEventListener('mouseenter', function() {
          var val = parseInt(star.dataset.value);
          stars.forEach(function(s, i) {
            s.classList.toggle('filled', i < val);
          });
          document.getElementById('starLabel').textContent = STAR_LABELS[val];
        });

        star.addEventListener('mouseleave', function() {
          stars.forEach(function(s, i) {
            s.classList.toggle('filled', i < reviewData.rating_overall);
          });
          document.getElementById('starLabel').textContent = reviewData.rating_overall ? STAR_LABELS[reviewData.rating_overall] : '';
        });
      });

      document.getElementById('btnRating').addEventListener('click', goNext);

      // ─── Outcomes ───────────────────────────────
      var OUTCOME_LABELS = {
        1: 'No change',
        2: 'Slight improvement',
        3: 'Noticeable improvement',
        4: 'Strong improvement',
        5: 'Significant improvement'
      };

      document.querySelectorAll('.outcome-scale').forEach(function(scale) {
        var key = scale.dataset.outcomeScale;
        var valueEl = document.querySelector('[data-outcome-value="' + key + '"]');

        scale.querySelectorAll('.outcome-scale__option').forEach(function(opt) {
          opt.addEventListener('click', function() {
            var val = parseInt(opt.dataset.val);
            reviewData[key] = val;
            scale.querySelectorAll('.outcome-scale__option').forEach(function(o) {
              o.classList.toggle('selected', parseInt(o.dataset.val) === val);
            });
            if (valueEl) valueEl.textContent = OUTCOME_LABELS[val];
          });
        });
      });

      // ─── Duration ───────────────────────────────
      document.querySelectorAll('[data-duration]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          reviewData.duration_of_use = btn.dataset.duration;
          document.querySelectorAll('[data-duration]').forEach(function(b) {
            b.classList.remove('selected');
          });
          btn.classList.add('selected');
          document.getElementById('btnDuration').disabled = false;
        });
      });

      document.getElementById('btnDuration').addEventListener('click', goNext);

      // ─── Recommend ──────────────────────────────
      document.querySelectorAll('[data-recommend]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          reviewData.would_recommend = btn.dataset.recommend === 'true';
          document.querySelectorAll('[data-recommend]').forEach(function(b) {
            b.classList.remove('selected');
          });
          btn.classList.add('selected');
          document.getElementById('btnRecommend').disabled = false;
        });
      });

      document.getElementById('btnRecommend').addEventListener('click', goNext);

      // ─── Written Review ─────────────────────────
      var reviewBody = document.getElementById('reviewBody');
      reviewBody.addEventListener('input', function() {
        document.getElementById('btnReview').disabled = reviewBody.value.trim().length < 10;
      });

      // ─── Media Upload ───────────────────────────
      var dropzone = document.getElementById('mediaDropzone');
      var mediaInput = document.getElementById('mediaInput');
      var previewsContainer = document.getElementById('mediaPreviews');

      dropzone.addEventListener('click', function() { mediaInput.click(); });

      dropzone.addEventListener('dragover', function(e) {
        e.preventDefault();
        dropzone.classList.add('dragover');
      });

      dropzone.addEventListener('dragleave', function() {
        dropzone.classList.remove('dragover');
      });

      dropzone.addEventListener('drop', function(e) {
        e.preventDefault();
        dropzone.classList.remove('dragover');
        handleFiles(Array.from(e.dataTransfer.files));
      });

      mediaInput.addEventListener('change', function() {
        handleFiles(Array.from(mediaInput.files));
        mediaInput.value = '';
      });

      function handleFiles(files) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];

          if (uploadedMedia.length >= MAX_FILES) {
            showError('Maximum ' + MAX_FILES + ' files allowed.');
            return;
          }

          if (ALLOWED_TYPES.indexOf(file.type) === -1) {
            showError('Unsupported file type. Use JPG, PNG, WEBP, or MP4.');
            continue;
          }

          var isVideo = file.type.startsWith('video/');
          var maxSize = isVideo ? MAX_VIDEO_SIZE : MAX_IMAGE_SIZE;
          if (file.size > maxSize) {
            showError((isVideo ? 'Videos' : 'Images') + ' must be under ' + (maxSize / 1024 / 1024) + ' MB.');
            continue;
          }

          hideError();
          var localUrl = URL.createObjectURL(file);
          var mediaItem = {
            file: file,
            localUrl: localUrl,
            remoteUrl: null,
            status: 'uploading',
            isVideo: isVideo
          };
          uploadedMedia.push(mediaItem);
          renderPreviews();
          uploadFile(mediaItem);
        }
      }

      async function uploadFile(mediaItem) {
        var formData = new FormData();
        formData.append('file', mediaItem.file);

        try {
          var res = await fetch(WORKER_URL + '/api/upload-media', {
            method: 'POST',
            body: formData
          });

          var data = await res.json();

          if (res.ok && data.url) {
            mediaItem.remoteUrl = data.url;
            mediaItem.status = 'done';
          } else {
            mediaItem.status = 'error';
          }
        } catch (err) {
          mediaItem.status = 'error';
        }

        renderPreviews();
      }

      function removeMedia(index) {
        URL.revokeObjectURL(uploadedMedia[index].localUrl);
        uploadedMedia.splice(index, 1);
        renderPreviews();
      }

      function renderPreviews() {
        previewsContainer.innerHTML = '';

        uploadedMedia.forEach(function(item, index) {
          var div = document.createElement('div');
          div.className = 'media-preview';

          if (item.isVideo) {
            var vid = document.createElement('video');
            vid.src = item.localUrl;
            vid.muted = true;
            div.appendChild(vid);
          } else {
            var img = document.createElement('img');
            img.src = item.localUrl;
            img.alt = 'Upload preview';
            div.appendChild(img);
          }

          var removeBtn = document.createElement('button');
          removeBtn.className = 'media-preview__remove';
          removeBtn.innerHTML = '&times;';
          removeBtn.addEventListener('click', function() { removeMedia(index); });
          div.appendChild(removeBtn);

          if (item.status === 'uploading') {
            var overlay = document.createElement('div');
            overlay.className = 'media-preview__uploading';
            overlay.innerHTML = '<div class="media-preview__spinner"></div>';
            div.appendChild(overlay);
          }

          if (item.status === 'error') {
            var errOverlay = document.createElement('div');
            errOverlay.className = 'media-preview__uploading';
            errOverlay.innerHTML = '<div style="font-size:11px;color:var(--pp-error);">Upload failed</div>';
            div.appendChild(errOverlay);
          }

          previewsContainer.appendChild(div);
        });

        dropzone.style.display = uploadedMedia.length >= MAX_FILES ? 'none' : '';
      }

      // ─── Build Summary + Navigate ───────────────
      // Skip = rating only: drop the headline and text, keep any uploaded media
      document.getElementById('btnReviewSkip').addEventListener('click', function() {
        buildSummaryAndNext(true);
      });
      document.getElementById('btnReview').addEventListener('click', function() {
        buildSummaryAndNext(false);
      });

      function buildSummaryAndNext(skipped) {
        reviewData.title = skipped ? '' : document.getElementById('reviewTitle').value.trim();
        reviewData.body = skipped ? '' : reviewBody.value.trim();

        // Collect uploaded media URLs
        reviewData.media_urls = uploadedMedia
          .filter(function(m) { return m.status === 'done' && m.remoteUrl; })
          .map(function(m) { return m.remoteUrl; });

        // Build summary stars
        var starStr = '';
        for (var i = 0; i < 5; i++) {
          starStr += i < reviewData.rating_overall ? '\u2605' : '\u2606';
        }
        document.getElementById('summaryStars').textContent = starStr;
        document.getElementById('summaryTitle').textContent = reviewData.title || '';
        document.getElementById('summaryBody').textContent = reviewData.body;

        // Media summary
        var summaryMedia = document.getElementById('summaryMedia');
        var summaryMediaPreviews = document.getElementById('summaryMediaPreviews');
        if (reviewData.media_urls.length > 0) {
          summaryMediaPreviews.innerHTML = '';
          uploadedMedia.filter(function(m) { return m.status === 'done'; }).forEach(function(item) {
            if (item.isVideo) {
              summaryMediaPreviews.innerHTML += '<div style="width:60px;height:60px;border-radius:6px;overflow:hidden;background:var(--pp-cream);display:flex;align-items:center;justify-content:center;font-size:20px;">&#9654;</div>';
            } else {
              summaryMediaPreviews.innerHTML += '<img src="' + item.localUrl + '" alt="Review media preview" style="width:60px;height:60px;border-radius:6px;object-fit:cover;">';
            }
          });
          summaryMedia.style.display = 'block';
        } else {
          summaryMedia.style.display = 'none';
        }

        // Product ratings summary
        var summaryProducts = document.getElementById('summaryProductRatings');
        var ratedProducts = Object.entries(productRatings).filter(function(entry) {
          return entry[1].rating > 0;
        });
        if (ratedProducts.length > 0) {
          var prodHtml = '<div style="font-size: 14px; font-weight: 500; margin-bottom: 8px;">Product ratings:</div>';
          ratedProducts.forEach(function(entry) {
            var handle = entry[0];
            var data = entry[1];
            var pStars = '';
            for (var j = 0; j < 5; j++) {
              pStars += j < data.rating ? '\u2605' : '\u2606';
            }
            prodHtml += '<div style="font-size: 14px; color: var(--pp-mid); margin-bottom: 4px;">'
              + '<span style="color: var(--pp-gold);">' + pStars + '</span> ' + data.title
              + (data.comment ? '<span style="font-weight: 300;"> \u2014 ' + data.comment + '</span>' : '')
              + '</div>';
          });
          summaryProducts.innerHTML = prodHtml;
          summaryProducts.style.display = 'block';
        } else {
          summaryProducts.style.display = 'none';
        }

        goNext();
      }

      // ─── Submit Review ──────────────────────────
      document.getElementById('btnSubmit').addEventListener('click', async function() {
        var btn = document.getElementById('btnSubmit');
        btn.disabled = true;
        btn.classList.add('loading');
        hideError();

        // Collect product ratings
        reviewData.product_ratings = Object.entries(productRatings)
          .filter(function(entry) { return entry[1].rating > 0; })
          .map(function(entry) {
            return {
              handle: entry[0],
              product_id: entry[1].productId,
              product_title: entry[1].title,
              rating: entry[1].rating,
              comment: entry[1].comment
            };
          });

        // Clean up null values
        var payload = {};
        Object.keys(reviewData).forEach(function(key) {
          if (reviewData[key] !== null && reviewData[key] !== '') {
            payload[key] = reviewData[key];
          }
        });

        try {
          var res = await fetch(WORKER_URL + '/api/submit-review', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });

          var data = await res.json();

          if (res.ok && data.success) {
            goToStep('r-done');
          } else {
            showError(data.error || 'Something went wrong. Please try again.');
            btn.disabled = false;
            btn.classList.remove('loading');
          }
        } catch (err) {
          showError('Could not connect. Please check your internet and try again.');
          btn.disabled = false;
          btn.classList.remove('loading');
        }
      });

      // ─── Error Handling ─────────────────────────
      function showError(msg) {
        var el = document.getElementById('errorMsg');
        el.textContent = msg;
        el.classList.add('visible');
      }

      function hideError() {
        document.getElementById('errorMsg').classList.remove('visible');
      }
    })();
